import React, { useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import { Field, reduxForm } from "redux-form";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { withStyles } from "@material-ui/core/styles";
import { Typography, Divider } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { renderField } from "../../../shared/components/form/RenderField";
import Button from "@material-ui/core/Button";
import { validate } from "../../../config/formValidation"
import { connect, useDispatch, useSelector } from "react-redux";
import { setResourcesDetails } from "redux/actions/resourcesAction"

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);
const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    justifyContent: "center",
  },
}))(MuiDialogActions);

function AddResources({
  isResourcesOpen,
  closeResourcesModal,
  handleSubmit,
  isEdit,
  initialValues,
  submitting,
  valid,
  handleResources,
}) {
  const dispatch = useDispatch()
  useEffect(() => {
    if (isEdit) dispatch(setResourcesDetails({}))
  }, [])
  return (
    <div>
      <Dialog
        onClose={closeResourcesModal}
        fullWidth
        open={isResourcesOpen}
      >
        <DialogTitle className="pb-0" onClose={closeResourcesModal}>
          {isEdit ? "Edit Resources" : "Create Resources"}
        </DialogTitle>
        <form
          className="login-form p-16 px-24"
          onSubmit={handleSubmit(handleResources)}
        >
          <DialogContent className="p-0 pt-10">
            <div>
              <Field name="id" component={renderField} hidden />
            </div>

            <div className="form__form-group">
              <Field
                name="subject"
                label="Subject"
                type="text"
                component={renderField}
                placeholder="Enter Subject/Title."
                startIcon="contactless"
                required
              />
            </div>

            <div className="form__form-group">
              <Field
                name="body"
                label="Description"
                type="text"
                component={renderField}
                placeholder="Description"
                startIcon="note"
                multiline={true}
                rows={4}
              />
            </div>
            <div className="form__form-group">
              <Field
                name="externalLink"
                label="External Link"
                component={renderField}
                type="url"
                placeholder="Include http:// or https://"
                className="input-without-border-radius"
                startIcon="link"
              />
            </div>
          </DialogContent>
          <DialogActions className="float-right p-0">
            <Button
              className="m-0"
              variant="outlined"
              color="secondary"
              onClick={closeResourcesModal}
            >
              Cancel
            </Button>
            <Button
              className="mx-10"
              variant="contained"
              type="submnit"
              color="primary"
              disabled={!valid || submitting}
            >
              Save
            </Button>

          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

export default connect((state) => ({
  initialValues: {
    id: state.resources.resourceById.id
      ? state.resources.resourceById.id
      : 0,

    subject: state.resources.resourceById.subject
      ? state.resources.resourceById.subject
      : "",
    body: state.resources.resourceById.body
      ? state.resources.resourceById.body
      : "",
    externalLink: state.resources.resourceById.link
      ? state.resources.resourceById.link
      : "",

  },
}))(
  reduxForm({
    form: "resourcesForm",
    validate,
    enableReinitialize: true,
  })(AddResources)
);
